import { assertNotNullish, } from '@synapex/tools/typescript';
import { coerceUrl } from '@synapex/tools/utils';
function getLd(ws) {
    if (ws.workspace_type === 'site') {
        return {
            workspace_type: 'site',
            link_id: ws.site_link_id,
        };
    }
    else {
        return {
            workspace_type: 'channel',
            link_id: ws.invite_link_id,
        };
    }
}
function pickLd({ link_id, workspace_type }) {
    return { link_id, workspace_type };
}
function extractLd({ link_id, workspace_type, ...rest }) {
    return [
        {
            link_id,
            workspace_type,
        },
        rest,
    ];
}
function getLdFromSnake(snakeIdObj) {
    if (typeof snakeIdObj.site_link_id === 'number') {
        return {
            workspace_type: 'site',
            link_id: snakeIdObj.site_link_id,
        };
    }
    else if (typeof snakeIdObj.invite_link_id === 'number') {
        return {
            workspace_type: 'channel',
            link_id: snakeIdObj.invite_link_id,
        };
    }
    return null;
}
function getLdFromSnakeOrThrow(snakeIdObj) {
    const r = getLdFromSnake(snakeIdObj);
    assertNotNullish(r, `getLdFromSnakeOrThrow: ${JSON.stringify(snakeIdObj)}`);
    return r;
}
function getLdFromCamel(camelIdObj) {
    if (typeof camelIdObj.siteLinkId === 'number') {
        return {
            workspace_type: 'site',
            link_id: camelIdObj.siteLinkId,
        };
    }
    else if (typeof camelIdObj.inviteLinkId === 'number') {
        return {
            workspace_type: 'channel',
            link_id: camelIdObj.inviteLinkId,
        };
    }
    return null;
}
function getLdFromCamelOrThrow(camelIdObj) {
    const r = getLdFromCamel(camelIdObj);
    assertNotNullish(r, `getLdFromCamelOrThrow: ${JSON.stringify(camelIdObj)}`);
    return r;
}
function getCamelFromLd(wd) {
    if (wd.workspace_type === 'site') {
        return {
            siteLinkId: wd.link_id,
        };
    }
    else {
        return {
            inviteLinkId: wd.link_id,
        };
    }
}
function getSnakeFromLd(wd) {
    if (wd.workspace_type === 'site') {
        return {
            site_link_id: wd.link_id,
        };
    }
    else {
        return {
            invite_link_id: wd.link_id,
        };
    }
}
const fromPrismaSiteLink = (siteLink) => {
    return {
        ...siteLink,
        workspace_type: 'site',
    };
};
const fromPrismaChannelLink = (channelLink) => {
    return {
        ...channelLink,
        workspace_type: 'channel',
    };
};
const fromPrismaOrThrow = (input) => {
    if (input.site_link) {
        return {
            workspace_type: 'site',
            ...input.site_link,
        };
    }
    else if (input.invite_link) {
        return {
            workspace_type: 'channel',
            ...input.invite_link,
        };
    }
    throw new Error(`fromPrismaOrThrow: ${JSON.stringify(input)}`);
};
const fromInviteHash = (inviteHash) => `https://t.me/+${inviteHash}`;
const siteLinkUrlFromSiteLink = (link, erid) => {
    const result = [];
    if (link.siteLinkUrl) {
        const { hostname, pathname } = link.siteLinkUrl;
        const url = coerceUrl(`${hostname}/${pathname}`);
        if (url) {
            result.push(url);
        }
    }
    if (link.utmLink) {
        const url = coerceUrl(link.utmLink.baseUrl);
        if (url) {
            if (erid) {
                url.searchParams.append('erid', erid);
            }
            result.push(url);
        }
    }
    return result.length > 0 ? result : null;
};
const siteLinkUrlFromUrl = ({ hostname, pathname }) => {
    return {
        hostname,
        pathname: pathname.replace(/^\/+|\/+$/g, ''),
    };
};
export const linkMethods = {
    siteLinkUrlFromSiteLink,
    siteLinkUrlFromUrl,
    fromPrismaSiteLink,
    fromPrismaChannelLink,
    getLd,
    extractLd,
    pickLd,
    getLdFromSnake,
    getLdFromSnakeOrThrow,
    getLdFromCamel,
    getLdFromCamelOrThrow,
    getCamelFromLd,
    getSnakeFromLd,
    fromPrismaOrThrow,
    fromInviteHash,
};
//# sourceMappingURL=link.js.map